import CourseRowSkeleton from './CourseRowSkeleton';

export default function RequirementPageSkeleton() {
    return (
        <div className="mt-2 w-full max-w-[1200px] mx-auto px-4 md:px-12 animate-pulse">
            <div className="grid grid-cols-1 md:grid-cols-[1fr_312px] gap-6">
                {/* Left */}
                <div className="min-w-0 pb-20">
                    <div className="mt-2 md:mt-3 mb-3">
                        {/* Program badge */}
                        <div className="flex items-center gap-2 mb-1">
                            <div className="w-8 h-8 rounded-full bg-gray-200 flex-shrink-0" />
                            <div className="h-3.5 w-36 bg-gray-200 rounded" />
                        </div>
                        {/* Requirement title */}
                        <div className="h-8 w-72 bg-gray-200 rounded mt-1" />
                    </div>
                    {/* Description lines */}
                    <div className="space-y-2 mb-4">
                        <div className="h-4 w-full bg-gray-100 rounded" />
                        <div className="h-4 w-5/6 bg-gray-100 rounded" />
                    </div>
                    {/* Course rows */}
                    <CourseRowSkeleton rows={5} />
                </div>

                {/* Right: sidebar */}
                <div className="hidden md:block bg-gray-50 rounded-md p-3 space-y-3 sticky top-4 self-start mt-2 md:mt-3">
                    <div className="h-4 w-40 bg-gray-200 rounded" />
                    <div className="h-3 w-28 bg-gray-100 rounded" />
                    <div className="h-1.5 w-full bg-gray-200 rounded-full" />
                    <div className="border-t border-gray-200 pt-3 space-y-1">
                        {[0, 1, 2, 3].map(i => (
                            <div key={i} className="h-8 w-full bg-gray-100 rounded-md" />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
